"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageButton = void 0;
const React = require("react");
const FontAwesome_1 = require("react-native-vector-icons/FontAwesome");
const theme_1 = require("../modules/theme");
const test_1 = require("../modules/test");
const react_native_1 = require("react-native");
class ImageButton extends React.Component {
    render() {
        const { icon, style, iconColor, onPress, iconSize, hitBoxSize, nativeID } = this.props;
        return (React.createElement(react_native_1.TouchableOpacity, { onPress: onPress, activeOpacity: 0.5, style: [styles.container, style], hitSlop: hitBoxSize
                ? {
                    top: hitBoxSize,
                    bottom: hitBoxSize,
                    left: hitBoxSize,
                    right: hitBoxSize
                }
                : undefined },
            React.createElement(FontAwesome_1.default, { nativeID: nativeID, testID: (0, test_1.getTestID)(nativeID), name: icon, size: iconSize || 20, color: iconColor || theme.textColor1 })));
    }
}
exports.ImageButton = ImageButton;
const theme = (0, theme_1.getTheme)();
const styles = react_native_1.StyleSheet.create({
    container: {
        borderWidth: 1,
        borderColor: theme.borderColor1,
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 40
    }
});
